import { __assign, __rest } from "tslib";
import React from 'react';
import { transformWireframeProps } from '../../../../utils/propUtils';
var VeltVideoPlayerControlsTotalTimeWireframe = function (props) {
    var children = props.children, remainingProps = __rest(props, ["children"]);
    var transformedProps = transformWireframeProps(remainingProps);
    return (React.createElement("velt-video-player-controls-total-time-wireframe", __assign({}, transformedProps), children));
};
export default VeltVideoPlayerControlsTotalTimeWireframe;
